import { createClient } from '@supabase/supabase-js';

export const supabaseUrl = 'https://puhcegfacazxteagytaw.supabase.co'; // 실제 URL로 바꿔주세요
export const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB1aGNlZ2ZhY2F6eHRlYWd5dGF3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA5MTU5NzQsImV4cCI6MjA2NjQ5MTk3NH0.0cmq8K3dfJPeldtL9DqCdd7V3bgmUEt9aBsXutj8wPE';             // 실제 키로 바꿔주세요

export const supabase = createClient(supabaseUrl, supabaseKey);
